/* src/app/common/components/chatbot/chatbot.component.scss */
.chatbot-fab {
  position: fixed;
  left: 20px;
  bottom: 20px;
  width: 56px;
  height: 56px;
  border: 0;
  border-radius: 50%;
  background: #f37021;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1050;
  transition: transform 0.2s ease;
  display: none;
}
.chatbot-fab:hover {
  transform: scale(1.08);
}
.chatbot-window {
  position: fixed;
  left: 20px;
  bottom: 90px;
  width: 40vw;
  min-width: 380px;
  height: 75vh;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 110px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1050;
}
.chatbot-header {
  background: #f37021;
  color: #fff;
  padding: 10px 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chatbot-close {
  background: transparent;
  border: 0;
  color: #fff;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}
.chatbot-body {
  position: relative;
  flex: 1;
}
.chatbot-body iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
.chatbot-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}
/*# sourceMappingURL=chatbot.component-HJKJRPOW.css.map */
